export const theme = {
  background: '#06101D',
  backgroundDeep: '#020711',
  sessions: '#21D4FD',
  minutes: '#FFAA33',
  text: '#F4F8FC',
  muted: '#7890A8',
  grid: '#173149',
  line: '#29445E',
} as const;

export const fontFamily =
  '"SF Pro Display", "SF Pro Text", "PingFang SC", "Microsoft YaHei", sans-serif';
